import React, { useState, useEffect, useRef } from "react";
import "./WithDraw.scss";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { getFromlocalstorage } from "../../../../../component/MaHoaDuLieu/MaHoaDuLieu";
import { useUser } from "../../../../../component/UserProvider/UserProvider";
import Notify from "../../../../../component/Notify/Notify";
import Loading from "../../../../../component/Loading/Loading";
import CheckCrypto from "../../../../../component/CheckCrypto/CheckCrypto";

const WithdrawForm = () => {
  const navigate = useNavigate();

  const [method, setMethod] = useState("bank");
  const [amount, setAmount] = useState("");
  const [receivedAmount, setReceivedAmount] = useState(0);
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setNotification] = useState("");
  const [notifyType, setNotifyType] = useState("error");

  const { user, fetchUser } = useUser();
  const hasFetched = useRef(false);

  const apiUrl = process.env.REACT_APP_API_BACKEND;

  const data = JSON.parse(getFromlocalstorage("data_u"));

  useEffect(() => {
    if (data && !hasFetched.current) {
      fetchUser(data._id);
      hasFetched.current = true;
    }
  }, [data, fetchUser]);

  const totalBalance =
    Number((user?.coins || 0).toFixed(0)).toLocaleString("en-US") || 0;

  const showNotify = (msg, type) => {
    setNotification(msg);
    setNotifyType(type);
  };

  // Nhập số tiền ngân hàng
  const handleBankAmountChange = (e) => {
    const value = e.target.value
      .replace(/,/g, "")
      .replace(/[^0-9]/g, "");

    setAmount(value);
  };

  // Nhập số tiền USDT
  const handleUsdtAmountChange = (e) => {
    let value = e.target.value;

    // Chỉ cho phép nhập số và 1 dấu chấm
    value = value.replace(/[^0-9.]/g, "");

    const parts = value.split(".");

    if (parts.length > 2) {
      value = parts[0] + "." + parts.slice(1).join("");
    }

    setAmount(value);

    const numericValue = Number(value) || 0;

    // method thực tế là "usdt", không phải "crypto"
    setReceivedAmount(
      method === "usdt" ? numericValue * 33 : numericValue * 1
    );
  };

  const handlePasswordChange = (e) => {
    const numericValue = e.target.value.replace(/[^0-9]/g, "");
    setPassword(numericValue);
  };

  const handleWithdraw = () => {
    if (Number(amount) < 100) {
      setNotification("จำนวนเงินถอนขั้นต่ำคือ 100!");
      setNotifyType("error");
      return;
    }

    if (!password) {
      setNotification("กรุณากรอกรหัสผ่านถอนเงิน!");
      setNotifyType("error");
      return;
    }
  };

  const handleCapchaSubmit = async () => {
    setLoading(true);

    try {
      const response = await axios.post(
        `${apiUrl}/ruttien/${data._id}`,
        {
          amount: Number(amount),
          type: method === "bank" ? "withdraw" : "withdraw-crypto",
          mkruttien: password,
        }
      );

      if (response.status === 200) {
        setNotification("ถอนเงินสำเร็จ!");
        setNotifyType("success");

        setAmount("");
        setReceivedAmount(0);
        setPassword("");

        setTimeout(() => {
          <Link
            to="/accounttk"
            state={{ tab: "history" }}
          ></Link>;
        }, 1000);
      }
    } catch (error) {
      let errorMessage = "เกิดข้อผิดพลาดในการถอนเงิน";

      if (error.response) {
        errorMessage =
          error.response.data.error || "ถอนเงินไม่สำเร็จ";

        setNotification(
          errorMessage === "Mật khẩu không chính xác"
            ? "รหัสผ่านไม่ถูกต้อง"
            : "ยอดเงินคงเหลือไม่เพียงพอ"
        );
      } else {
        setNotification("ยอดเงินคงเหลือไม่เพียงพอ");
      }

      setNotifyType("error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Loading isLoading={loading} />

      <form
        className="withdraw-form"
        onSubmit={(e) => {
          e.preventDefault();
          handleWithdraw();
        }}
      >
        {/* Phương thức rút tiền */}
        <div className="form-item">
          <label>ถอนเงินไปยัง</label>

          <div className="radio-group">
            <label
              className={`radio ${
                method === "bank" ? "checked" : ""
              }`}
            >
              <input
                type="radio"
                value="bank"
                checked={method === "bank"}
                onChange={() => {
                  setMethod("bank");
                  setAmount("");
                  setReceivedAmount(0);
                }}
              />

              ธนาคาร
            </label>

            <label
              className={`radio ${
                method === "usdt" ? "checked" : ""
              }`}
            >
              <input
                type="radio"
                value="usdt"
                checked={method === "usdt"}
                onChange={() =>
                  CheckCrypto(
                    navigate,
                    setMethod,
                    showNotify
                  )
                }
              />

              เครือข่าย
            </label>
          </div>
        </div>

        {/* Rút tiền ngân hàng */}
        {method === "bank" && (
          <>
            <div className="form-item">
              <label>ยอดเงินปัจจุบัน</label>

              <input
                type="text"
                value={totalBalance}
                disabled
              />
            </div>

            <div className="form-item required">
              <label>จำนวนเงินที่ถอน</label>

              <div className="amount-input-wrapper">
                <input
                  type="text"
                  inputMode="numeric"
                  placeholder="กรอกจำนวนเงิน"
                  value={
                    amount
                      ? Number(amount).toLocaleString("en-US")
                      : ""
                  }
                  onChange={handleBankAmountChange}
                  autoComplete="off"
                />

                <span className="currency">
                  THB
                </span>
              </div>
            </div>

            <div className="form-item required">
              <label>รหัสผ่านถอนเงิน</label>

              <input
                type="password"
                inputMode="numeric"
                maxLength={6}
                value={password}
                onChange={handlePasswordChange}
                placeholder="กรอกรหัสผ่านถอนเงิน"
              />
            </div>
          </>
        )}

        {/* Rút tiền USDT */}
        {method === "usdt" && (
          <>
            <div className="form-item">
              <label>ยอดเงินปัจจุบัน</label>

              <input
                type="text"
                value={totalBalance}
                disabled
              />
            </div>

            <div className="form-item required">
              <label>จำนวน USDT ที่ถอน</label>

              <div className="amount-input-wrapper">
                <input
                  type="text"
                  inputMode="decimal"
                  placeholder="กรอกจำนวน USDT"
                  value={amount}
                  onChange={handleUsdtAmountChange}
                  autoComplete="off"
                />

                <span className="currency">
                  USDT
                </span>
              </div>
            </div>

            <div className="form-item">
              <label>อัตราแลกเปลี่ยนปัจจุบัน</label>

              <input
                type="text"
                value="33"
                disabled
              />
            </div>

            <div className="form-item">
              <label>จำนวนเงินที่ถอน</label>

              <div className="amount-input-wrapper">
                <input
                  type="text"
                  value={Number(
                    receivedAmount || 0
                  ).toLocaleString("en-US")}
                  disabled
                />

                <span className="currency">
                  THB
                </span>
              </div>
            </div>

            <div className="form-item required">
              <label>รหัสผ่านถอนเงิน</label>

              <input
                type="password"
                inputMode="numeric"
                maxLength={6}
                value={password}
                onChange={handlePasswordChange}
                placeholder="กรอกรหัสผ่านถอนเงิน"
              />
            </div>
          </>
        )}

        {/* Buttons */}
        <div className="form-item buttons">
          <button
            type="submit"
            className="btn primary"
            onClick={handleCapchaSubmit}
          >
            ยืนยัน
          </button>

          <button
            type="reset"
            className="btn reset"
            onClick={() => {
              setAmount("");
              setReceivedAmount(0);
              setPassword("");
            }}
          >
            รีเซ็ต
          </button>
        </div>
      </form>

      {message && (
        <Notify
          message={message}
          type={notifyType}
          setcontent={setNotification}
        />
      )}
    </>
  );
};

export default WithdrawForm;